export default "__VITE_ASSET__BQLOQURb__"